import { render } from "./TheAnomalies.vue?vue&type=template&id=7d08d21e"
import script from "./TheAnomalies.vue?vue&type=script&lang=js"
export * from "./TheAnomalies.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__